import React, { useEffect, useState } from 'react';
import { getActivityLogs } from '../api/reportApi';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';

const ActivityLogPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getActivityLogs()
      .then(data => {
        setLogs(data);
      })
      .catch(err => {
        console.error("❌ خطا در دریافت لاگ‌ها:", err);
        if (err.response) {
          console.error("📡 پاسخ سرور:", err.response.data);
          setError(`کد وضعیت: ${err.response.status} - پیام: ${err.response.data.message || 'خطای ناشناخته'}`);
        } else {
          setError('ارتباط با سرور برقرار نشد');
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}  dir="rtl">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (logs.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="info">هیچ لاگی ثبت نشده</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography variant="h5" gutterBottom>📜 گزارش فعالیت‌ها</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>کاربر</TableCell>
              <TableCell>نقش</TableCell>
              <TableCell>مسیر</TableCell>
              <TableCell>متد</TableCell>
              <TableCell>کد وضعیت</TableCell>
              <TableCell>زمان</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.userId}</TableCell>
                <TableCell>{log.role}</TableCell>
                <TableCell>{log.endpoint}</TableCell>
                <TableCell>{log.method}</TableCell>
                <TableCell>{log.statusCode}</TableCell>
                <TableCell>{log.timestamp}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ActivityLogPage;
